import RevenueCard from "./RevenueCard";
import InfoTooltip from "../InfoTooltip";
import { trpc } from "../../trpc";

type RevenueBaseSectionProps = {
  selectedMonth: string;
  selectedYear: string;
  trmValue: number;
  formatCurrency: (value: number) => string;
  formatUSD: (value: number) => string;
  revenueType?: string;
};

const RevenueBaseSection = ({
  selectedMonth,
  selectedYear,
  trmValue,
  formatCurrency,
  formatUSD,
  revenueType,
}: RevenueBaseSectionProps) => {
  const { data: revenueBaseData, isLoading: isRevenueBaseLoading } =
    trpc.revenue.baseRevenue.useQuery(
      {
        year: parseInt(selectedYear),
        month: parseInt(selectedMonth),
        revenueType: revenueType === "all" ? undefined : revenueType,
      },
      {
        enabled: !!selectedMonth && !!selectedYear,
      }
    );

  const totalConsumptionToUse =
    revenueBaseData?.detail?.reduce((acc, merchant) => acc + merchant.consumptionToUse, 0) || 0;
  const realMrr = totalConsumptionToUse / trmValue;
  const realArr = realMrr * 12;

  return (
    <div>
      <div className="mb-2">
        <p className="text-lg font-semibold text-gray-700 inline">
          Revenue basado en el consumo base del merchant - MRR base
        </p>
        <InfoTooltip
          text="Suma de la tarifa mínima de todos los merchants de development + suma del consumo real de los merchants rentals (que es el consumo mínimo o el consumo real, siempre y cuando sea mayor al mínimo)."
          placement="top"
          size="md"
        />
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-6 w-full">
        <RevenueCard
          title="Active Merchants"
          value={revenueBaseData?.activeMerchants || 0}
          subtitle="Merchants with consumption"
          isLoading={isRevenueBaseLoading}
          formatValue={(value) => value.toString()}
        />

        <RevenueCard
          title="Total Billable Revenue"
          value={totalConsumptionToUse}
          subtitle="Total billable revenue (COP)"
          isLoading={isRevenueBaseLoading}
          formatValue={formatCurrency}
        />

        <RevenueCard
          title="Real MRR"
          value={realMrr}
          subtitle="Monthly Recurring Revenue (USD)"
          isLoading={isRevenueBaseLoading}
          formatValue={formatUSD}
        />

        <RevenueCard
          title="Real ARR"
          value={realArr}
          subtitle="Annual Recurring Revenue (USD)"
          isLoading={isRevenueBaseLoading}
          formatValue={formatUSD}
        />
      </div>
    </div>
  );
};

export default RevenueBaseSection;
